<template>
    <div>
        <form-base v-on="$listeners" v-if="!isCard" :value="value" :filter="filter" :hide-delete="hideDelete" :readonly="readonly" :hide-offset="hideOffset" :api-method="apiMethod" :fields="fields" :form-title="formTitle" :is-hover="isHover" />
        <card-base v-on="$listeners" v-if="isCard" :item="value" :filter="filter" :card-color="cardColor" :readonly="readonly" :fields="fields" :title="formTitle" />
    </div>
</template>

<script>
    export default {
        props: [
            'value',
            'filter',
            'hideDelete',
            'readonly',
            'hideOffset',
            'isCard',
            'cardColor',
            'isHover'
        ],

        components: {
            formBase: () => import('../components/FormBase'),
            cardBase: () => import('../components/CardBase')
        },

        data() {
            return {
                feedForm: () => import('../forms/FeedForm'),
                fileForm: () => import('../forms/FileForm'),
                memberForm: () => import('../forms/MemberForm'),
                fields: [
                    { type: 'autocomplete', text: 'Member', value: 'memberId', rules: [v => !!v || 'Member is required'], isRequired: true, form: () => import('./MemberForm'), apiMethod: 'Members', claim: 'Members' },
                    { type: 'datetime', text: 'On', value: 'on', rules: [v => !!v || 'On is required'], isRequired: true },
                    { type: 'autocomplete', text: 'Feed', value: 'feedId', rules: [v => !!v || 'Feed is required'], isRequired: true, form: () => import('./FeedForm'), apiMethod: 'Feeds', claim: 'Feeds' },
                    { type: 'text', text: 'Dose Rate', value: 'doseRate', rules: [v => !!v || 'Dose Rate is required', v => !(v && v.length > 50) || 'Dose Rate must be less than 50 characters'], isRequired: true, maxLength: 50 },
                    { type: 'text', text: 'Product Name', value: 'productName', rules: [v => !(v && v.length > 100) || 'Product Name must be less than 100 characters'], maxLength: 100 },
                    { type: 'file', text: 'Invoice File', value: 'invoiceFileId', rules: [], form: () => import('./FileForm'), apiMethod: 'Files' },
                ],
                apiMethod: 'FeedPurchases',
                formTitle: 'Feed Purchase',
            }
        },
    };
</script>
